import {createBrowserRouter, createHashRouter} from 'react-router-dom';

// A data router is required by react-admin's unsaved-change navigation guards.
// ADR-0001 (artaNftBE/docs/adr): pe web adrese reale (/artisti/x), indexabile; in Cordova
// aplicatia ruleaza din fisiere locale, fara server care sa raspunda pe cai adanci -> hash.
// index.js creeaza routerul dupa deviceready, deci window.cordova e deja definit in APK.
export const esteCordova = () => typeof window !== 'undefined' && !!window.cordova;

let routerCurent = null;

export const createAppRouter = (element) => {
    const creeaza = esteCordova() ? createHashRouter : createBrowserRouter;
    routerCurent = creeaza([{path: '*', element}]);
    return routerCurent;
};

// Navigare din cod aflat in afara componentelor (ex. authProvider-ul react-admin).
export const navigheaza = (cale) => {
    if (routerCurent) return routerCurent.navigate(cale);
    if (esteCordova()) window.location.hash = cale;
    else window.history.pushState({}, '', cale);
    return Promise.resolve();
};
